import { io } from 'socket.io-client';
import ServerUtils from '../../data/server';
import AuthService from './auth';

let socket = null;
let currentBranchCode = null;

function normalizeBranchCode(branchCode) {
  return branchCode == null ? '' : String(branchCode).trim();
}

function getDashboardNamespaceUrl() {
  const base = ServerUtils.getBaseUrl().replace(/\/api\/?$/, '');
  return `${base.replace(/\/$/, '')}/dashboard`;
}

export function connectDashboardSocket() {
  const auth = AuthService.get();
  if (!auth || !auth.access_token) return null;

  if (socket && socket.connected) return socket;

  socket = io(getDashboardNamespaceUrl(), {
    path: '/socket.io',
    auth: { token: auth.access_token },
    extraHeaders: { Authorization: `Bearer ${auth.access_token}` },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionDelayMax: 10000,
  });

  return socket;
}

export function joinBranchRoom(branchCode) {
  if (!socket) return;

  const normalizedBranch = normalizeBranchCode(branchCode);
  if (!normalizedBranch) return;

  const doJoin = () => {
    if (currentBranchCode && currentBranchCode !== normalizedBranch) {
      socket.emit('leave', { branchCode: currentBranchCode });
    }
    socket.emit('join', { branchCode: normalizedBranch });
    currentBranchCode = normalizedBranch;
  };

  if (socket.connected) {
    doJoin();
  } else {
    socket.once('connect', doJoin);
  }
}

export function onStatusChanged(handler) {
  if (socket) socket.on('outboundOrder:statusChanged', handler);
}

export function offStatusChanged(handler) {
  if (socket) socket.off('outboundOrder:statusChanged', handler);
}

export function onSocketConnect(handler) {
  if (socket) socket.on('connect', handler);
}

export function onSocketDisconnect(handler) {
  if (socket) socket.on('disconnect', handler);
}

export function disconnectDashboardSocket() {
  if (socket && currentBranchCode) {
    socket.emit('leave', { branchCode: currentBranchCode });
    currentBranchCode = null;
  }
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
